import { Routes } from '@angular/router';
import {
  BreadCrumbRouteConfig,
  RenderInterfaceGuard
} from 'viggo-sistemas-core-web';

export const routesAdminVendas: Routes = [
  {
    path: 'terminais',
    canActivate: [RenderInterfaceGuard],
    loadChildren: () =>
      import('@modules/terminal/terminal.module').then(m => m.TerminalModule),
    data: {
      module: 'VEN_TERMINAL',
      subMenuKey: 'VENDAS',
      menuKey: 'CONFIGURACOES',
      breadcrumb: {
        label: 'Terminais',
        icon: 'pi pi-fw pi-desktop'
      } as BreadCrumbRouteConfig
    }
  },
  {
    path: 'pdv',
    canActivate: [RenderInterfaceGuard],
    loadChildren: () =>
      import('@modules/caixa-pdv/caixa-pdv.module').then(m => m.CaixaPdvModule),
    data: {
      module: 'VEN_PDV',
      menuKey: 'VENDAS',
      breadcrumb: {
        label: 'Caixa',
        icon: 'pi pi-fw pi-desktop'
      } as BreadCrumbRouteConfig
    }
  },
  {
    path: 'registros_caixa',
    canActivate: [RenderInterfaceGuard],
    loadChildren: () =>
      import('@modules/registros_caixa/registros_caixa.module').then(
        m => m.RegistroCaixaModule
      ),
    data: {
      module: 'VEN_CAIXA',
      menuKey: 'VENDAS',
      breadcrumb: {
        label: 'Registros dos caixas',
        icon: 'pi pi-fw pi-money-bill'
      } as BreadCrumbRouteConfig
    }
  },
  {
    path: 'tabela_preco_fabricas',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'VEN_TABELA_PRECO_FABRICA',
      subMenuKey: 'VENDAS',
      menuKey: 'CONFIGURACOES',
      breadcrumb: {
        label: 'Tabela de preço da fábrica',
        icon: 'mdi mdi-file-table-box-multiple-outline'
      }
    },
    loadChildren: () =>
      import('@modules/tabela_preco_fabrica/tabela_preco_fabrica.module').then(
        m => m.TabelaPrecoFabricaModule
      )
  },
  {
    path: 'pedido_venda',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'VEN_PEDIDO_VENDA',
      menuKey: 'VENDAS',
      breadcrumb: {
        label: 'Pedido de venda',
        icon: 'pi pi-fw pi-shopping-cart'
      }
    },
    loadChildren: () =>
      import('@app/modules/pedido-venda/pedido-venda.module').then(
        m => m.PedidoVendaModule
      )
  },
  {
    path: 'ordem_de_servico',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'VEN_ORDEM_SERVICO',
      menuKey: 'VENDAS',
      breadcrumb: {
        label: 'Ordem de serviço',
        icon: 'pi pi-fw pi-wrench'
      }
    },
    loadChildren: () =>
      import('@app/modules/ordem-de-servico/ordem-de-servico.module').then(
        m => m.OrdemDeServicoModule
      )
  }
];
